// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center, Group } from '@/components/ui/layout';
import { Title, Text, Button } from '@/components/ui/core';
import { IconArrowLeft, IconLogout, IconCheck, IconArrowRight } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function LogoutPage() {
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  const handleLogout = () => {
    setIsLoggedOut(true);
  };

  if (isLoggedOut) {
    return (
      <AuthLayoutWrapper variant="simple">
        <Stack gap="lg" align="center">
          <Center
            style={{
              width: 80,
              height: 80,
              borderRadius: 20,
              backgroundColor: 'var(--mantine-color-green-light)',
            }}
          >
            <IconCheck size={40} color="var(--mantine-color-green-6)" />
          </Center>

          <Stack align="center" gap="xs">
            <Title order={2} ta="center">Logged out successfully</Title>
            <Text c="dimmed" ta="center" maw={300}>
              You have been securely logged out of your account.
            </Text>
          </Stack>

          <Stack gap="sm" w="100%">
            <Button
              component={Link}
              to="/app/demo/auth-pages/login/simple"
              fullWidth
              rightSection={<IconArrowRight size={16} />}
            >
              Sign in again
            </Button>

            <Button
              component={Link}
              to="/app/demo/auth-pages"
              variant="subtle"
              fullWidth
            >
              Back to Auth Pages Demo
            </Button>
          </Stack>
        </Stack>
      </AuthLayoutWrapper>
    );
  }

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/other"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to Other Pages
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                backgroundColor: 'var(--mantine-color-orange-light)',
              }}
            >
              <IconLogout size={36} color="var(--mantine-color-orange-6)" />
            </Center>
            <Title order={2} ta="center">Sign out</Title>
            <Text c="dimmed" size="sm" ta="center" maw={300}>
              Are you sure you want to sign out of your account?
            </Text>
          </Stack>
        </Center>

        {/* Actions */}
        <Stack gap="sm">
          <Button
            fullWidth
            color="red"
            leftSection={<IconLogout size={16} />}
            onClick={handleLogout}
          >
            Yes, sign me out
          </Button>

          <Button
            component={Link}
            to="/app/demo/auth-pages"
            variant="outline"
            fullWidth
          >
            Cancel
          </Button>
        </Stack>

        {/* Info */}
        <Text ta="center" size="xs" c="dimmed">
          You'll need to sign in again to access your account.
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
